import React from 'react';

import styled from '@emotion/styled';

import PageHeader from '../../../components/Layout/PageHeader';
import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import SetupDriverList from './SetupDriverList';

const DriverSetup = () => {
  return (
    <Page title='Logirate | Driver List'>
      <PageLayout>
        <Container>
          <PageHeader
            title='Driver Setup'
            description='How would you like to set up your driver list?'
          />
          <SetupDriverList />
        </Container>
      </PageLayout>
    </Page>
  );
};

export default DriverSetup;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
